module.exports = __webpack_public_path__ + "static/media/bulletin.efc90f12.svg";